import { get } from 'src/apis/apiService'
import config from 'src/config'

const RECEIVE_SPEAKERS = 'RECEIVE_SPEAKERS'
const SELECTED_SPEAKER = 'SELECTED_SPEAKER'
const initialState = {
  speakers: [],
  selectedSpeaker: null
}

export default function speakerReducer(state = initialState, action) {
  switch (action.type) {
    case RECEIVE_SPEAKERS:
      return {
        ...state,
        speakers: action.speakers,
      }
      case SELECTED_SPEAKER:
      return {
        ...state,
        selectedSpeaker: action.speaker,
      }
    default:
      return state
  }
}

export function getSpeakers() {
  return (dispatch) => {
    get(
      `${config.apiUrl}/api/speakers`,
      (data) => {
        const sortedSpeakers = data.speakers && data.speakers.length > 0 ? [...data.speakers].sort((a, b) => a.position - b.position) : []
        dispatch(receiveSpeakers(sortedSpeakers))
      },
      (error) => {
        console.error(error)
      }
    )
  }
}

export function receiveSpeakers(speakers) {
  return {
    type: RECEIVE_SPEAKERS,
    speakers: speakers,
  }
}

export function setSpeaker(speaker) {
  return (dispatch) => {
    dispatch({ type: SELECTED_SPEAKER, speaker: speaker })
  }
}
